module.exports = {
	"apertureWidth": "Anchura de apertura",
	"apertureLength": "Longitud de apertura",
	"apertureGap1": "Separación de apertura 1",
	"apertureGap2": "Separación de apertura 2",
	"ballDiameter": "Diámetro de la bola",
	"bodyOffset": "Desfase del cuerpo",
	"bodyLength": "Longitud del cuerpo",
	"bodyDiameter": "Diámetro del cuerpo",
	"bodyHeight": "Altura del cuerpo",
	"bodyColor": "Color del cuerpo",
	"componentFamily": "Familia de componentes",
	"colPitch": "Paso entre columnas",
	"chipArrayNote": "* L1 y b1 son opcionales.",
	"crystalNote": "* Seleccione la cota opcional de (D, D2, L). Las diferentes combinaciones pueden producir tamaños de plataforma de implantación de componentes diferentes.",	
	"densityLevel": "Nivel de densidad",	
	"femaleStandoffNote": "* La plataforma de agujero de montaje es opcional y se puede generar introduciendo valores para las cotas que se muestran en la imagen izquierda. El diámetro de agujero (b) se utiliza para la generación de agujeros de montaje y para el modelo mecánico de espaciador sin roscado interno.",
	"footprintOrigin": "Origen de implantación de componentes",
	"hPinPitch": "Paso de pasador horizontal",
	"hTerminalGap": "Separación de la borna horizontal",
	"hTerminalTailLength": "Longitud del extremo final de la borna horizontal",
	"innerThreadDepth": "Profundidad de la rosca interior",
	"innerThreadSize": "Tamaño de la rosca interior",
	"innerThreadDesignation": "Designación de la rosca interior",
	"leadDiameter": "Diámetro de entrada/salida",
	"leadSpan": "Tramo de entrada/salida",
	"leadSpan1": "Tramo de entrada/salida 1",
	"leadSpan2": "Tramo de entrada/salida 2",
	"leadShape": "Forma de la rosca",
	"largerTerminalLength": "Longitud de la borna mayor",
	"largerTerminalWidth": "Ancho de la borna mayor",
	"maleFemaleStandoffNote": "* La plataforma de agujero de montaje es opcional y se puede generar introduciendo valores para las cotas que se muestran en la imagen izquierda. El diámetro de agujero (b) se utiliza para la generación de agujeros de montaje.",
	"mapSilkscreen": "Asignar modo de pantalla de silencio a cuerpo",
	"optionalDimensionNote": "* Seleccione la cota opcional de (D, D2, L). Las diferentes combinaciones pueden producir tamaños de plataforma de implantación de componentes diferentes.",
	"oddTerminalLength": "Longitud de la borna impar",
	"oddTerminalWidth": "Anchura de la borna impar",
	"optionalDimension": "Cota opcional",	
	"partialThread": "Rosca parcial",	
	"pasteCoverage": "Pegar cobertura",
	"producibilityLevel": "Nivel de producibilidad",
	"pinPitch": "Paso de pasador",
	"padToHoleRatio": "Proporción entre plataformas y agujeros",
	"padRoundness": "Redondez de la plataforma",
	"pinNumbering": "Numeración de los pasadores",
	"postLength": "Longitud del montante",
	"postThreadSize": "Tamaño de rosca del montante",
	"postThreadDesignation": "Designación de rosca del montante",
	"rowPitch": "Paso de fila",
	"tabWidth": "Anchura de la lengüeta",
	"tabLength": "Longitud de la lengüeta",
	"terminalThickness": "Grosor de la borna",
	"terminalWidth": "Anchura de la borna",
	"terminalLength": "Longitud de la borna",
	"terminalGap": "Separación de la borna",
	"terminalCCGap": "Separación de centro-centro de la borna",
	"terminalCCGap1": "Separación de centro-centro de la borna 1",
	"terminalCCGap2": "Separación de centro-centro de la borna 2",
	"terminalTailLength": "Longitud del extremo final de la borna",
	"terminalPostLength": "Longitud del montante de la borna",
	"terminalType": "Tipo de borna",	
	"threadDepth": "Profundidad de rosca",
	"threadSize": "Tamaño de la rosca",
	"threadDesignation": "Designación de la rosca",	
	"threaded": "Roscado",
	"truncateMiddlePin": "Pasador medio truncado",		
	"vPinPitch": "Paso de pasador vertical",
	"vTerminalGap": "Separación de la borna vertical",
	"vTerminalTailLength": "Longitud del extremo final de la borna vertical",
	"#Rows": "N.º filas",
	"#Cols": "N.º columnas",
	"#Pins": "N.º pasadores",
	"#DPins": "N.º pasadores (lado D)",
	"#EPins": "N.º pasadores (lado E)",
	"padShape": "Forma de la plataforma",
	"RESISTOR": "Resistencia",
	"NONPOLARIZED_CAPACITOR": "Condensador - No polarizado",
	"POLARIZED_CAPACITOR": "Condensador polarizado",
	"DIODE": "Diodo",
	"FUSE": "Fusible",
	"INDUCTOR": "Inductor",
	"POLARIZED_INDUCTOR": "Inductor polarizado",
	"NONPOLARIZED_INDUCTOR": "Inductor - No polarizado",
	"LRCCW": "En sentido antihorario desde la parte inferior izquierda",
	"LRCW": "En sentido horario desde la parte superior izquierda",
	"ZZBT": "En zigzag desde la parte inferior izquierda",
	"PIN_ONE": "Pasador 1",
	"CENTER_PADS": "Centro de plataformas",
	"female": "Hembra",
	"male": "Macho",
	"maleFemale": "Macho-hembra",
	"ROUND": "Redondo",
	"HEX": "Hexadecimal",
	"SQUARE": "Cuadrado",
	"Round": "Redondo",
	"Square": "Cuadrado",
	"RoundedSquare": "Cuadrado redondeado",
	"Rectangle": "Rectángulo",
	"Black": "Negro",
	"Green": "Verde",
	"Blue": "Azul",
	"Yellow": "Amarillo",
	"Amber": "Ámbar",
	"Brown": "Marrón",
	"Cyan": "Cian",
	"Maroon": "Granate",
	"Grey": "Gris",
	"Silver": "Plata",
	"Purple": "Morado",
	"Red": "Rojo",
	"White": "Blanco",
	"Most (A)": "Máximo (A)",
	"Nominal (B)": "Nominal (B)",
	"Least (C)": "Mínimo (C)",
	"Most (M)": "Máximo (M)",
	"Nominal (N)": "Nominal (N)",
	"Least (L)": "Mínimo (L)",
	"IC": "Circuito integrado (IC)",
	"PRECISION_INDUCTOR": "Inductor de precisión",
	"LED": "LED",
	"THERMISTOR": "Termistor",
	"POLARIZED_DIODE": "Diodo",
	"VARISTOR": "Varistor",
	"FERRITE_BEAD": "Núcleo de ferrita",
	"SOIC_SOP": "SOIC, SOP",
	"QFP": "QFP",
	"CFP": "CFP",
	"CQFP": "CQFP",
	"QFN": "QFN",
	"SOT23": "SOT23",
	"SOTFL": "SOTFL",
	"SOT223": "SOT223",
	"TO_DPAK": "TO, DPAK",
	"SOT143": "SOT143",
	"CHIP": "Chip",
	"SOD": "SOD",
	"MOLDED_BODY": "Cuerpo moldeado",
	"SODFL": "SODFL",
	"DFN_2": "DFN-2",
	"DFN_3": "DFN-3",
	"DFN_4": "DFN-4",
	"ECAP": "Remate E",
	"CRYSTAL": "Cristal",
	"BGA": "BGA",
	"MELF": "MELF",
	"CHIP_ARRAY_TWO_SIDE_FLAT_CONCAVE": "Matriz de chip, plano/cóncavo de 2 lados",
	"CHIP_ARRAY_FOUR_SIDE_FLAT_CONCAVE": "Matriz de chip, plano/cóncavo de 4 lados",
	"CHIP_ARRAY_TWO_SIDE_CONVEX": "Matriz de chip, convexo de 2 lados",
	"PLCC": "PLCC",
	"OSCILLATOR_CORNER_CONCAVE": "Esquina de oscilador cóncava",
	"OSCILLATOR_J_LEAD": "Entrada/salida en J de oscilador",
	"OSCILLATOR_L_BEND": "Codo en L de Oscilador",
	"SOJ": "SOJ",
	"AXIAL": "Axial",
	"DIP": "DIP",
	"PIN_HEADER_STRAIGHT": "Cabeza de pasador (macho) recta",
	"PIN_HEADER_RA": "Cabeza de pasador (macho) en ángulo recto",
	"RECEPTACLE_HEADER_STRAIGHT": "Cabeza de receptáculo (hembra) recta",
	"RECEPTACLE_HEADER_RA": "Cabeza de receptáculo (hembra) en ángulo recto",
	"SON_DFN": "SON (DFN)",
	"RADIAL_GENERIC": "Genérico radial (redondo)",
	"RADIAL_LED": "LED radial (redondo)",
	"CRYSTAL_HC49": "Cristal (HC49)",
	"FEMALE_STANDOFF": "Separación/Separador hembra",
	"MALE_FEMALE_STANDOFF": "Separación macho-hembra",
	"SNAP_LOCK": "Bloqueo de forzado",
	"Optional_D": "D (tramo de entrada/salida)",
	"Optional_D2": "D2 (separación de borna)",
	"Optional_L": "L (longitud de la borna)",
	"CONCAVE": "Cóncavo",
	"FLAT": "Plano",
	"Oblong": "Oblongo",
	"Collapsing_Ball": "Bola contraída",
	"Non_Collapsing_Ball": "Bola no contraída",
	"mountingHolePad": "Plataforma de agujeros de montaje",
	"withVias": "Con vías",
	"viasCount": "Recuento de vías",
	"viaDiameter": "Diámetro de vía",
	"viaOffset": "Desfase de vía desde el centro del agujero",
	"viaThermalRelief": "Relieve térmico de vía",
	"radialLedNote": "* c no es aplicable para formas de entrada/salida redondeadas.",
	"lockHeight": "Altura de bloqueo",
	"overrideLockDiameter": "Modificar diámetro de bloqueo",
	"lockDiameter": "Diámetro de bloqueo",
	"overridePitch": "Modificar paso de pasador",
	"bodyWidth": "Anchura del cuerpo",
	"padWidth": "Anchura de refuerzo",
	"plated": "Placa",
	"ViaOffset": "Desfase de vía desde el centro del agujero",
	"holeDiameter": "Diámetro del agujero",
	"snapLockNote1": "* El diámetro de bloqueo (E1) se calcula automáticamente en función del diámetro del cuerpo (E) y el diámetro del agujero (b). Sin embargo, puede proporcionar un valor personalizado modificando el diámetro de bloqueo.",
	"snapLockNote2": "* El diámetro del agujero (b) no debe ser igual al diámetro del cuerpo (E) y al diámetro de bloqueo (E1).",
	"leadWidth": "Anchura de entrada/salida",
	"leadThickness": "Grosor de entrada/salida",
	"boardThickness": "Grosor del tablero",
	"error1": "No implementado.",
	"fabricationTolerance": "Tolerancia de fabricación", 
	"placementTolerance": "Tolerancia de posición",
	"CAPACITOR": "Condensador - No polarizado",
	"CAPACITOR_NONPOLARIZED": "Condensador - No polarizado",
	"CAPACITOR_NON_POLARIZED": "Condensador - No polarizado",
	"FILTER": "Filtro", 
	"TRANSISTOR": "Transistor",
	"ecapNote": "* Seleccione la cota opcional de (D, D2, L). Las diferentes combinaciones pueden producir tamaños de plataforma de implantación de componentes diferentes.",
	"maximum": "Máximo", 
	"nominal": "Nominal", 
	"minimum": "Mínimo",
	"bodyShape": "Forma del cuerpo",
	"customSolderPaste": "Pegado de soldadura con estaño personalizado",
	"thermalPad": "Plataforma térmica",
	"thermalPadLength": "Longitud de la plataforma térmica",
	"thermalPadWidth": "Anchura de la plataforma térmica",
	"RoundedRectangle": "Rectángulo redondeado",
	"extendedEdgeLength": "Longitud de arista extendida",
	"Generator": " Generador",
	"axialNote": "* El paso de pasador se calcula automáticamente en función del tamaño del cuerpo, la borna y el nivel de productividad para que la implantación de componentes cumpla con IPC. Sin embargo, puede proporcionar un valor personalizado mediante la modificación del paso de pasador para crear una implantación de componentes no compatible con IPC.",
	"baseHeight": "Altura de la base",
	"CHIP_LED": "LED de chip",
	"updatePreview": "Actualizar vista preliminar",
	"Custom": "Personalizar",
	"ledColorNote": "* Introduzca un valor hexadecimal para el color de cuerpo personalizado.",
	"customBodyColor": "Color de cuerpo personalizado",							
	"lensShape": "Forma de lente",
	"domeDiameter": "Diámetro de la cúpula",
	"RECT_FLAT_TOP": "Rectángulo con parte superior plana",
	"RECT_DOMED_TOP": "Rectángulo con parte superior en cúpula",
	'customFootprint': 'Implantación de componentes personalizada',
	'customPadLength': 'Longitud de plataforma personalizada',
	'customPadWidth': 'Anchura de plataforma personalizada',
	'customPadGap': 'Plataforma personalizada para borna de plataforma',
	'customOddPadWidth': 'Anchura de plataforma impar personalizada',
	'customOddPadLength': 'Longitud de plataforma impar personalizada',
	'customPadDiameter': 'Diámetro de plataforma personalizado',
	'customPadSpan1': 'Tramo de plataforma personalizado 1',
	'customPadSpan2' : 'Tramo de plataforma personalizado 2',
	'customPadPitch' : 'Paso de plataforma personalizado',
	'pinPitch1' : 'Paso de pasador 1',
	'customPadGap1': 'Plataforma personalizada para borna de plataforma 1',
	'Optional_g': 'g (borna de plataforma personalizada)',
	'Optional_p': 'p (paso de plataforma personalizado)',

	// JS Widgets
	"New_Library": "Nueva biblioteca",
	"Components": "Componentes",
	"Component": "Componente",
	"Symbols": "Símbolos",
	"Symbol": "Símbolo",
	"Footprints": "Implantaciones",
	"Footprint": "Implantación de componentes",
	"Packages": "Paquetes",
	"Package": "Paquete",
	"No": "No",
	"Name": "Nombre",
	"Pins": "Pasadores",
	"Pads": "Plataformas",
	"Description": "Descripción",
	"Variants": "Variantes",
	"Type": "Tipo",
	"Hub_URN": "Hub URN",
	"Hub_Version": "Hub Version",
	"Library_io_URN": "URN de Library.io",
	"Library_io_Version": "Versión de Library.io",
	"Link": "Víncular",
	"Rename": 'Cambiar nombre',
	"Edit_Description": 'Editar descripción',
	"Duplicate": 'Duplicar', // verb, not noun.  ie "Make a copy"
	"Create_New_3D_Model": 'Crear nuevo modelo 3D',
	"Attach_Copy_Existing_3D_Model": 'Adjuntar copia del modelo 3D existente',
	"Edit": 'Editar',
	"Delete": 'Suprimir',
	"Remove_From": 'Eliminar de',
	"Update_To_Latest": 'Actualizar a la versión más reciente',
	"Create_New_Symbol": 'Crear nuevo símbolo',
	"Create_New_Footprint": 'Crear nueva implantación de componentes',
	"Create_New_Component": 'Crear nuevo componente',
	"Create_New_Package": 'Crear paquete nuevo',
	"Delete_Package_Children_Warning": "Esto también suprimirá los paquetes utilizados por esta implantación de componentes.",
	"No_Search_Results": "No hay resultados de búsqueda",
	"No_Library_Loaded": "Biblioteca no cargada",
	"Library_Stored_Fusion_Hub": "Esta biblioteca se almacena en your Fusion Hub.",
	"Library_Linked_Managed_Library": "Esta biblioteca está vinculada a una biblioteca Library.io administrada.",
	"Library_Local_Changes": "Esta biblioteca tiene cambios que no se han transferido a Library.io. Para transferirlos, vaya a la barra de herramientas 'Administrar'.",
	"Library_Remote_Changes": "Esta biblioteca tiene nuevas actualizaciones que se pueden extraer de Library.io. Para extraerlas, vaya a la barra de herramientas Administrar.",
	"View_on_Library_io": "Ver en Library.io",
	"Used_In": "Usado en",
	"No_Selection": "No hay selección",

	"No_Footprints": "No hay implantaciones de componentes",
	"No_Symbols": "No hay símbolos",
	"No_Components": "No hay componentes",
	"No_Packages": "No hay paquetes",

	"Package_Loading_Message": "Espere mientras se guarda y se carga el paquete.",
	"Attributes": "Atributos",
	"View_Attributes": "Ver atributos",
	"Edit_Attributes": "Ver atributos",
	"Edit_Description": "Editar descripción",
	
	"Use_Placeholder": "Usar marcador de posición",
	"Placeholder_Message": "Use una forma de marcador de posición cuando no hay ningún modelo 3D asociado a la implantación de componentes.",

	"Hub": "Hub",
	"New_Symbol": 'Nuevo símbolo',
	"New_Footprint": 'Nueva implantación de componentes',
	"New_Component": 'Nuevo componente',
	"New_Package": 'Nuevo paquete',

	"Asset_Ahead":  "Local changes are detected.  To publish these changes to Library.io, use the 'Manage' toolbar.",
	"Package_Behind_Lio": "La actualización del paquete Library.io está disponible. Haga clic con el botón derecho y seleccione Actualizar.",
	"Package_Behind_Fusion": "La actualización del paquete de Fusion está disponible. Haga clic con el botón derecho y seleccione Actualizar.",
	"Package_Behind_Both": "Hay disponible una actualización de paquete. Haga clic con el botón derecho y seleccione Actualizar.",
	"Package_On_Lio":  "This package exists only on Library.io.  Editing it will create a linked model in your Fusion Hub.",
	"Package_Behind_Blocked": "La biblioteca se debe actualizar antes de poder extraer los cambios de componentes. Para actualizar la biblioteca, utilice la barra de herramientas Administrar.",
}